//eslint-disable-next-line @typescript-eslint/no-var-requires
export const version: string = require('../../package.json').version;
